
import moment from 'moment'

var commonPlatformFormatter = function(v) {
    if(v > 0) {
        var s= '';

        for(var i=0; i<v; i++) {
            s += '<span style="color:green">✓</span>'
        }
        return s;
    }
    else {
        return "";
    }
};

var table = {
    name: 'realestate.product_posting_summary_7',
    list_views: {
        filters: [
            {
                col: 'posting_status',
                type: 'select',
                value: 'Đang đăng tin',
            },
            {
                col: 'code',
                type: 'text',
                value: null,
            },
            {
                col: 'fullname',
                type: 'text',
                value: null,
            },
            {
                col: 'street',
                type: 'text',
                value: null,
            },
            {
                col: 'isfavored',
                type: 'boolean',
                value: false
            },
            {
                col: 'address',
                type: 'text',
                value: null
            },
            {
                col: 'content',
                type: 'text',
                value: null,
            },
            {
                col: 'contract_type',
                type: 'multi-select',
                value: [],
            },
        ],
        sorts: {
            last_posting_date: 'desc'
        },
        columns: {
            default_data: 
                [
                    'id',
                    'fullname',
                    'code',
                    'street',
                    'address',
                    // 'platforms',
                    'zalo_1',
                    'zalo_2',
                    'fb_tuan_golden',
                    'fb_rv_1',
                    'web_agnd',
                    'fb_ads',
                    'gg_ads',
                    'last_posting_date',
                    'days_since_last_posting',
                    'posting_reminder',
                    'posting_status',
                    'is_public'
                ],
            freelancer_data: 
                [
                    'id',
                    'fullname',
                    'code',
                    'street',
                    'address',
                    // 'platforms',
                    'zalo_1',
                    'fb',
                    'fb_rv_1',
                    'last_posting_date',
                    'days_since_last_posting',
                    'posting_reminder',
                    'posting_status',
                    'isfavored'
                ]
        }
    },

    list_views_readonly: {
        filters: [
            {
                col: 'posting_status',
                type: 'select',
                value: 'Đang đăng tin',
            },
            {
                col: 'code',
                type: 'text',
                value: null,
            },
            {
                col: 'fullname',
                type: 'text',
                value: null,
            },
            {
                col: 'content',
                type: 'text',
                value: null
            },
            {
                col: 'street',
                type: 'text',
                value: null,
            },
            {
                col: 'isfavored',
                type: 'boolean',
                value: false
            },
            {
                col: 'address',
                type: 'text',
                value: null
            },
        ],
        sorts: {
            last_posting_date: 'desc'
        },
        columns: {
            default_data: 
                [
                    'code',
                    'content',
                    'content_img_url',
                    'product_url',
                    'street',
                    'address',
                    'price',
                    'priceForRent',
                    'sale',
                    'status',
                    // 'platforms',
                    
                    'last_posting_date'
                ],
            freelancer_data: 
                [
                    'id',
                    'fullname',
                    'code',
                    'content',
                    'content_img_url',
                    'product_url',
                    'street',
                    'address',
                    'price',
                    'priceForRent',
                    'sale',
                    'status',
                    'last_posting_date'
                ],
            admin_data: 
                [
                    'id',
                    'fullname',
                    'code',
                    'content',
                    'content_img_url',
                    'product_url',
                    'street',
                    'address',
                    'price',
                    'priceForRent',
                    'sale',
                    'status',
                    // 'platforms',
                    
                    'last_posting_date'
                ],
        }
    },
    input_view: {
    },
    columns: {
        freelancer_data: {
            id: {
                'name': 'id',
                'type': 'Id',
                'alias': 'ID',
            },
            code: {
                'name': 'code',
                'type': 'text',
                'alias': 'Mã sản phẩm',
            },
            fullname: {
                'name': 'fullname',
                'type': 'text',
                'alias': 'Họ tên',
            },
            content_img_url: {
                'name': 'content_img_url',
                'type': 'text',
                'alias': 'Link hình ảnh',
            },
            product_url: {
                'name': 'product_url',
                'type': 'text',
                'alias': 'Link sản phẩm',
            },
            street: {
                'name': 'street',
                'type': 'text',
                'alias': 'Tên đường',
            },
            address: {
                'name': 'address',
                'type': 'text',
                'alias': 'Địa chỉ',
            },
            platforms: {
                'name': 'platforms',
                'type': 'text',
                'alias': 'Nơi đã post',
            },
            zalo_1: {
                'name': 'zalo_1',
                'type': 'text',
                'alias': 'Zalo 1',
                formatter: commonPlatformFormatter
            },
            fb: {
                'name': 'fb',
                'type': 'text',
                'alias': 'Facebook',
                formatter: commonPlatformFormatter
            },
            fb_rv_1: {
                'name': 'fb_rv_1',
                'type': 'text',
                'alias': 'FB RV 1',
                formatter: commonPlatformFormatter
            },
            last_posting_date: {
                'name': 'last_posting_date',
                'type': 'text',
                'alias': 'Lần đăng gần nhất',
                formatter: (value) => {
                    return moment(value).format('DD/MM');
                }
            },
            posting_dates: {
                'name': 'posting_dates',
                'type': 'text',
                'alias': 'Lần đăng',
            },
            posting_status: {
                'name': 'posting_status',
                'type': 'text',
                'alias': 'Trạng thái đăng tin',
                'options': [
                    'Đang đăng tin',
                    'Đã hoàn tất'
                ]
            },
            posting_reminder: {
                'name': 'posting_reminder',
                'type': 'number',
                'alias': 'Nhắc nhở sau',
            },
            days_since_last_posting: {
                'name': 'days_since_last_posting',
                'type': 'text',
                'alias': 'Lần đăng gần nhất',
                formatter: (value) => {
                    if(value > 0)
                        return value + ' ngày trước';
                    
                    return '';
                }
            },
            isfavored: {
                'name': 'isfavored',
                'type': 'boolean',
                'alias': 'Ưa thích'
            },
            price: {
                'name': 'price',
                'type': 'number',
                'alias': 'Giá kêu bán (tr)',
            },
            priceForRent: {
                'name': 'priceForRent',
                'type': 'number',
                'alias': 'Giá cho thuê (tr)',
            },
            sale: {
                'name': 'sale',
                'type': 'text',
                'alias': 'Sale',
    
                options: [
                    'NHI',
                    'TUẤN',
                    'KIM',
                    'CTV-NH',
                    'NGUYÊN',
                    'Telehang'
                ]
            },
            status: {
                'name': 'status',
                'type': 'text',
                'alias': 'Trạng thái',
                options: [
                    'Đang bán',
                    'Bán hoặc Cho thuê',
                    'Đã bán',
                    'Ngưng bán',
                    'Cho thuê',
                    'Ngưng cho thuê'
                ]
            },
            contract_type: {
                'name': 'contract_type',
                'type': 'text',
                'alias': 'Hợp đồng môi giới',
                options: [
                    'Không có HĐ',
                    'Ký HĐ MG',
                    'Ký HĐ MG độc quyền'
                ]
            }
        },
        default_data: {
            id: {
                'name': 'id',
                'type': 'Id',
                'alias': 'ID',
            },
            code: {
                'name': 'code',
                'type': 'text',
                'alias': 'Mã sản phẩm',
            },
            fullname: {
                'name': 'fullname',
                'type': 'text',
                'alias': 'Họ tên',
            },
            content: {
                'name': 'content',
                'type': 'text',
                'alias': 'Nội dung tin',
            },
            content_img_url: {
                'name': 'content_img_url',
                'type': 'link',
                'alias': 'Link hình ảnh',
            },
            product_url: {
                'name': 'product_url',
                'type': 'text',
                'alias': 'Link sản phẩm',
            },
            street: {
                'name': 'street',
                'type': 'text',
                'alias': 'Tên đường',
            },
            address: {
                'name': 'address',
                'type': 'text',
                'alias': 'Địa chỉ',
            },
            platforms: {
                'name': 'platforms',
                'type': 'text',
                'alias': 'Nơi đã post',
            },
            zalo_1: {
                'name': 'zalo_1',
                'type': 'text',
                'alias': 'Zalo 1',
                formatter: commonPlatformFormatter
            },
            zalo_2: {
                'name': 'zalo_2',
                'type': 'text',
                'alias': 'Zalo 2',
                formatter: commonPlatformFormatter
            },
            fb_tuan_golden: {
                'name': 'fb_tuan_golden',
                'type': 'text',
                'alias': 'FB Tuan Golden',
                formatter: commonPlatformFormatter
            },
            fb: {
                'name': 'fb',
                'type': 'text',
                'alias': 'Facebook',
                formatter: commonPlatformFormatter
            },
            fb_rv_1: {
                'name': 'fb_rv_1',
                'type': 'text',
                'alias': 'FB RV 1',
                formatter: commonPlatformFormatter
            },
            fb_rv_2: {
                'name': 'fb_rv_2',
                'type': 'text',
                'alias': 'FB RV 2',
                formatter: commonPlatformFormatter
            },
            web_rv_1: {
                'name': 'web_rv_1',
                'type': 'text',
                'alias': 'Web RV 1',
                formatter: commonPlatformFormatter
            },
            web_rv_2: {
                'name': 'web_rv_2',
                'type': 'text',
                'alias': 'Web RV 2',
                formatter: commonPlatformFormatter
            },
            web_agnd: {
                'name': 'web_agnd',
                'type': 'text',
                'alias': 'Web AGND',
                formatter: commonPlatformFormatter
            },
            fb_agnd: {
                'name': 'fb_agnd',
                'type': 'text',
                'alias': 'FB AGND',
                formatter: commonPlatformFormatter
            },
            fb_ads: {
                'name': 'fb_ads',
                'type': 'text',
                'alias': 'FB Ads',

                formatter: commonPlatformFormatter
            },
            gg_ads: {
                'name': 'gg_ads',
                'type': 'text',
                'alias': 'GG Ads',

                formatter: commonPlatformFormatter
            },
            last_posting_date: {
                'name': 'last_posting_date',
                'type': 'text',
                'alias': 'Lần đăng gần nhất',
                formatter: (value) => {
                    return moment(value).format('DD/MM');
                }
            },
            posting_dates: {
                'name': 'posting_dates',
                'type': 'text',
                'alias': 'Lần đăng',
            },
            posting_status: {
                'name': 'posting_status',
                'type': 'text',
                'alias': 'Trạng thái đăng tin',
                'options': [
                    'Đang đăng tin',
                    'Đã hoàn tất'
                ]
            },
            posting_reminder: {
                'name': 'posting_reminder',
                'type': 'number',
                'alias': 'Nhắc nhở sau',
            },
            days_since_last_posting: {
                'name': 'days_since_last_posting',
                'type': 'text',
                'alias': 'Lần đăng gần nhất',
                formatter: (value) => {
                    if(value > 0)
                        return value + ' ngày trước';
                    
                    return '';
                }
            },
            isfavored: {
                'name': 'isfavored',
                'type': 'boolean',
                'alias': 'Ưa thích'
            },
            is_public: {
                'name': 'is_public',
                'type': 'boolean',
                'alias': 'Hiển thị cho CTV',
                formatter: commonPlatformFormatter
            },
            price: {
                'name': 'price',
                'type': 'number',
                'alias': 'Giá kêu bán (tr)',
            },
            priceForRent: {
                'name': 'priceForRent',
                'type': 'number',
                'alias': 'Giá cho thuê (tr)',
            },
            sale: {
                'name': 'sale',
                'type': 'text',
                'alias': 'Sale',
    
                options: [
                    'NHI',
                    'TUẤN',
                    'KIM',
                    'CTV-NH',
                    'NGUYÊN',
                    'Telehang'
                ]
            },
            status: {
                'name': 'status',
                'type': 'text',
                'alias': 'Trạng thái',
                options: [
                    'Đang bán',
                    'Bán hoặc Cho thuê',
                    'Đã bán',
                    'Ngưng bán',
                    'Cho thuê',
                    'Ngưng cho thuê'
                ]
            },
            contract_type: {
                'name': 'contract_type',
                'type': 'text',
                'alias': 'Hợp đồng môi giới',
                options: [
                    'Không có HĐ',
                    'Ký HĐ MG',
                    'Ký HĐ MG độc quyền'
                ]
            }
        }
    }
}

export default {
    table_name: table.name,
    filter_orders: table.filter_orders,
    list_views: table.list_views,
    list_views_readonly: table.list_views_readonly,
    input_view: table.input_view,
    columns: table.columns
}